import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, makeStyles, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import 'translations/translations';
import { organizationActions } from 'actions/organizationActions';
import { ApplicationState } from 'store';

interface ParamTypes {
  orgId: string;
}

type StepProps = {
  stepTitleString: string;
  buttonText: string;
};

const useStyles = makeStyles((theme) => ({
  noMargine: {
    marginTop: 0,
  },
  flagStyles: {
    width: '2em',
    height: '1rem',
    marginRight: '0.5em',
    position: 'relative',
    top: '0.15rem',
  },
  error: {
    color: theme.palette.error.main,
    textAlign: 'right',
    fontSize: '0.8rem',
  },
}));

const CreateDepartmentStep: React.FC<StepProps> = () => {
  const dispatch = useDispatch();
  const [inputs, setInputs] = useState({
    departmentName: '',
    departmentNumber: '',
  });
  const { t } = useTranslation(['translations']);
  const { orgId } = useParams<ParamTypes>();
  const classes = useStyles();

  const deptError = useSelector(
    (state: ApplicationState) => state.department?.error,
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  useEffect(() => {
    dispatch({
      type: 'DISABLE_BUTTON',
      disabled: inputs.departmentName.length < 2,
    });
  }, [inputs]);

  const callbackFn = () => {
    dispatch(
      organizationActions.createDept(
        orgId,
        inputs.departmentName,
        parseInt(inputs.departmentNumber),
      ),
    );
  };

  useEffect(() => {
    // capture changed input
    dispatch({ type: 'SET_CALLBACK', callbackFn });
  }, [inputs]);

  useEffect(() => {
    dispatch({ type: 'DEPARTMENT_STATE_RESET' });
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={t('organization_page.create_dept.create_dept_step.dept_name')}
          name="departmentName"
          autoFocus
          onChange={handleChange}
          className={classes.noMargine}
          required
        ></TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          margin="normal"
          type="number"
          fullWidth
          label={t(
            'organization_page.create_dept.create_dept_step.dept_number',
          )}
          name="departmentNumber"
          onChange={handleChange}
          className={classes.noMargine}
        ></TextField>
        <Typography className={classes.error}>
          {!!deptError && deptError}
        </Typography>
      </Grid>
    </>
  );
};

export { CreateDepartmentStep };
